import styled from '@emotion/styled';
import { BodyMedium, BodyMediumLink, Row } from '../../../styles';
import { shouldForwardProps } from '../../../utils';

const ContactCardItemContainer = styled(Row)`
    gap: ${({ theme }) => theme.spacing(2)};
    padding-top: ${({ theme }) => theme.spacing(1)};
    padding-bottom: ${({ theme }) => theme.spacing(1)};
    padding-right: ${({ theme }) => theme.spacing(3)};

    > svg {
        height: 40px;
        width: 40px;
        border-radius: 20px;
        padding: 10px;
        background-color: ${({ theme }) => theme.colors.secondaryDark};
    }
`;

const ContactCardBodyMediumLink = styled(BodyMediumLink, shouldForwardProps)`
    white-space: normal;
    word-break: break-word;
`;

const ContactCardBodyMedium = styled(BodyMedium, shouldForwardProps)`
    white-space: normal;
    word-break: break-word;
`;

export { ContactCardItemContainer, ContactCardBodyMediumLink, ContactCardBodyMedium };
